import { useContext, useState } from "react";
import "./cards-gallery.css"
import CardModal from "../card-modal/card-modal";
import { AuthContext } from "../../utils/AuthContext";
import { addCardToUserDocument, addLikedCardToUserDocument, addWishlistedCardToUserDocument, UnlikeCardFromUserDocument, UnwishlistCardFromUserDocument } from "../../firebase";

export default function CardsGallery({ mode, cards, ownedCards = [], setUserInfo, likedCards = [], wishlistedCards = [], options = {
    displayRarity: false,
    displayMarketPrice: false,
    displayName: true,
    displayID: true,
} }) {

    const { authState } = useContext(AuthContext);

    const [modal, setModal] = useState(false);  
    const [currentCardData, setCurrentCardData] = useState(null);

    const handleDisplayModal = (cardData) => {
        setModal(true)
        setCurrentCardData(cardData)
    }

    const handleAddCard = (e, cardID) => {
        e.stopPropagation();
        addCardToUserDocument(authState.uid, cardID).then(() => {
            setUserInfo((prevUserInfo) => ({
                ...prevUserInfo,
                owned_cards: [...prevUserInfo.owned_cards, cardID],
            }));
        })
    }

    const handleLikeCard = (e, cardID, add) => {
        e.stopPropagation();
        if (add) {
            addLikedCardToUserDocument(authState.uid, cardID).then(() => {
                setUserInfo((prevUserInfo) => ({
                    ...prevUserInfo,
                    liked_cards: [...prevUserInfo.liked_cards, cardID],
                }));
            })
        } else {
            UnlikeCardFromUserDocument(authState.uid, cardID).then(() => {
                setUserInfo((prevUserInfo) => ({
                    ...prevUserInfo,
                    liked_cards: prevUserInfo.liked_cards.filter((id) => id !== cardID),
                }));
            });
        }
    }

    const handleWishlistCard = (e, cardID, add) => {
        e.stopPropagation();
        if (add) {
            addWishlistedCardToUserDocument(authState.uid, cardID).then(() => {
                setUserInfo((prevUserInfo) => ({
                    ...prevUserInfo,
                    wishlisted_cards: [...prevUserInfo.wishlisted_cards, cardID],
                }));
            })
        } else {
            UnwishlistCardFromUserDocument(authState.uid, cardID).then(() => {
                setUserInfo((prevUserInfo) => ({
                    ...prevUserInfo,
                    wishlisted_cards: prevUserInfo.wishlisted_cards.filter((id) => id !== cardID),
                }));
            });
        }
        
    }

    return <div className="cards-gallery full-width">
        {cards.map((card) => (
            <div key={card.id} className="card" onClick={() => handleDisplayModal(card)}>
                <div class="image-container">
                    {card.card_image == null ? (
                        <img src={`${process.env.PUBLIC_URL}/assets/placeholder.jpg`} alt={card.name} className={(mode == "missing-cards" || ownedCards.includes(card.card_image_id)) ? undefined : "missing-card"}/>
                    ) : (
                        <img src={card.card_image} alt={card.name} className={(mode == "missing-cards" || ownedCards.includes(card.card_image_id)) ? undefined : "missing-card"}/>
                    )}

                    <div className="card-options">
                        {options.displayRarity && <div className="rarity">
                            <p>{card.rarity}</p>
                        </div>}
                        {options.displayMarketPrice && <div className="market-price">
                            <p>${card.market_price}</p>
                        </div>}
                    </div>

                </div>

                {options.displayName && <p className="card-name">{card.card_name}</p>}
                {options.displayID && <p className="card-id">{card.card_image_id}</p>}
            
                    <div className="card-shortcuts">
                        {!ownedCards.includes(card.card_image_id) && ( <div className="add-card" onClick={(e) => handleAddCard(e, card.card_image_id)} >
                            <img src={`${process.env.PUBLIC_URL}/assets/304947.svg`} alt="add" height="20" width="20" />
                        </div>)}

                        <div className={`like-card ${likedCards.includes(card.card_image_id) ? "liked" : ""}`} onClick={(e) => handleLikeCard(e, card.card_image_id, !likedCards.includes(card.card_image_id))}>
                            <img src={`${process.env.PUBLIC_URL}/assets/heart-icon.svg`} alt="like" height="20" width="20" />
                        </div>

                        <div className={`wishlist-card ${wishlistedCards.includes(card.card_image_id) ? "wishlisted" : ""}`} onClick={(e) => handleWishlistCard(e, card.card_image_id, !wishlistedCards.includes(card.card_image_id))}>
                            <img src={`${process.env.PUBLIC_URL}/assets/bookmark-mark-pin-svgrepo-com.svg`} alt="wishlist" height="20" width="20" />
                        </div>
                    </div>

            </div>
        ))}
        {modal && <CardModal cardData={currentCardData} setModal={setModal} ownedCards={ownedCards} setUserInfo={setUserInfo} likedCards={likedCards} wishlistedCards={wishlistedCards}/>}            
    </div>
}